import { push } from 'react-router-redux';
import { all, takeEvery, put, call , select } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { flow } from '../modules/flow';
import { types, actions } from '../modules/usuario';
import { actions as enderecosActions } from '../modules/enderecos';
import usuarioService from '../../commons/services/usuario';
import { ROUTES } from '../../commons/routes/routes';

export default function* loginSaga() {
	yield takeEvery(types.USER_LOGIN, login);
	yield takeEvery(types.USER_LOGOUT, logout);
	yield takeEvery(types.USER_PASSWORD_CHANGE, changePassword);
	yield takeEvery(types.USER_FIND, find);
	yield takeEvery(types.USER_EDIT, edit);
}

function* login(action) {
	const force = action.meta && action.meta.force;

	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => usuarioService.login(action.payload)),
				call(delay, force ? 0 : 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.updateUserStore({ authenticated: true, ...data }));

			if (!force) {
				// se houver uma URL dinâmica pendente no localStorage, redireciona para o handler
				const dynamicUrl = localStorage.getItem('dynamicRedirectUrl');
				const url = dynamicUrl
					? ROUTES.OAUTH2_DYNAMIC_REDIRECT.path
					: (action.payload.redirectUrl || action.payload.redirecPageDefault);
				yield put(push(url));
			}
		}
	});
}

function* logout(action) {
	console.log('logout', action);

	yield* flow({
		type: action.type,

		fnTry: function*() {
			try {
				// aqui antes dele rodar yield put(actions.removeUserStore({}));

				const authProvider = yield select(state => state.usuario && state.usuario.authProvider);
				console.log(authProvider);
				yield put(actions.removeUserStore({}));
				if ( authProvider ) {
					const [data] = yield all([
										call(() => usuarioService.getLogoutUrl(authProvider)),
										call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
									]);
					if (action.payload.exibeGovBr) {
						window.open(data, '_blank');
					}
					if (action.payload.exibeMtLogin) {
						window.open(data, '_blank');
					}
				}
			} catch (e) {
				// bug logout backend catch para deixar limpar user store e redirect
				console.log('Error logout ', e);
			} finally {
				// callback
				if (action.payload && typeof action.payload === 'function') {
					action.payload();
				}
				// redirecionar para o início
				yield put(push(ROUTES.LOGIN.path));
			}
		},
		fnCatch: function*() {
			yield put(actions.removeUserStore({}));
		}
	});
}

function* changePassword(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			yield all([
				call(() => usuarioService.alterarSenha(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
		}
	});
}

function* find(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => usuarioService.get()),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.updateUserStore({ dadosCadastrais: data }));

			yield put(
				enderecosActions.consultarMunicipio({
					codigo_ibge: '',
					nome: '',
					sigla_uf: data.sg_unidade_federal
				})
			);
		},

		fnCatch: function*() {
			// não exibir mensagem de erro...
		}
	});
}

function* edit(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => usuarioService.edit(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
			yield put(actions.updateUserStore({ dadosCadastrais: data }));

			yield put(
				enderecosActions.consultarMunicipio({
					codigo_ibge: '',
					nome: '',
					sigla_uf: data.sg_unidade_federal
				})
			);
		}
	});
}
